import React, { useState } from 'react';
import {
  FiEdit2,
  FiUploadCloud, FiEdit3
} from 'react-icons/fi';

import './AdminActions.css';
import FormModal from './FormModal';
import Tooltip from "@mui/material/Tooltip"; 
import 'react-tooltip/dist/react-tooltip.css';
import FormModalBulk from './FormModalBulk';
import { motion } from "framer-motion";
import QuestionFormModal from '../Admin-Dashboard-Component/FormModalsQuickAdminActions/QuestionFormModal'

const AdminActions = () => {
  const [activeForm, setActiveForm] = useState(null);
  const [questionFormOpen, setQuestionFormOpen] = useState(false); // ✅ Fix for open/setOpen

  const openForm = (formType) => {
    setActiveForm(formType);
    if (formType === "questionManual") {
      setQuestionFormOpen(true);
    }
  };

  const closeForm = () => {
    setActiveForm(null);
    setQuestionFormOpen(false);
  };

  const handleQuestionSubmit = (formData) => {
    console.log("Submitted Question:", formData);
    closeForm();
  };

  // Framer Motion Variants
  const cardVariants = {
    hidden: { opacity: 0, y: 40, scale: 0.95 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
    hover: { scale: 1.05, boxShadow: "0px 12px 24px rgba(0,0,0,0.15)" }
  };

  return (
    <>
      < div className="admin-actions">
        {/* <div className="admin-card">
          <h3>
            <FiBookOpen className="card-icon" />
            Add Exam
          </h3>
          <button onClick={() => openForm("exam")}
            id='add-exam-btn'
          >+ Add Exam</button>
          <Tooltip anchorSelect="#add-exam-btn"
            offset={12}
            place="bottom-end"
            style={{
              backgroundColor: "#6f40c1", // matching your theme
              color: "#fff",
              fontSize: "0.9rem",
              padding: "8px 12px",
              borderRadius: "6px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
            }}
          >
            Create a new exam
          </Tooltip>
        </div> */}

        {/* <div className="admin-card">
          <h3>
            <FiCheckSquare className="card-icon" />
            Add Answers
          </h3>
          <button onClick={() => openForm("answer")} id='add-answers-btn'>+ Add Answers</button>
          <Tooltip
            anchorSelect="#add-answers-btn"
            place="bottom-end"
            offset={10}
            style={{
              backgroundColor: "#fd7e14", // Orange color
              color: "#fff",
              fontWeight: "500",
              fontSize: "0.9rem",
              padding: "8px 14px",
              borderRadius: "6px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
            }}
          >
            Provide answers
          </Tooltip>

        </div> */}

          {/* Bulk Upload Card */}
        <motion.div
          className="admin-card"
          variants={cardVariants}
          initial="hidden"
          animate="visible"
          whileHover="hover"
        >
          <h3>
            <FiUploadCloud className="card-icon upload" />
            Add Questions (Bulk Upload)
          </h3>
          <Tooltip
            title="Upload multiple questions at once using an Excel/CSV file"
            placement="bottom"
            arrow
          >
            <button onClick={() => openForm("questionBulk")}>+ Bulk Upload</button>
          </Tooltip>
        </motion.div>

        {/* Manual Upload Card */}
        <motion.div
          className="admin-card"
          variants={cardVariants}
          initial="hidden"
          animate="visible"
          whileHover="hover"
        >
          <h3>
            <FiEdit3 className="card-icon manual" />
            Add Questions (Manually)
          </h3>
          <Tooltip
            title="Add questions one by one manually"
            placement="bottom"
            arrow
          >
            <button onClick={() => openForm("questionManual")}>+ Manual Upload</button>
          </Tooltip>
        </motion.div>
      </div>

      {activeForm === "questionManual" && (
        <QuestionFormModal
          isOpen={questionFormOpen}
          onClose={closeForm}
          onSubmit={handleQuestionSubmit}
        />
      )}

      {activeForm === "questionBulk" && (
        <FormModalBulk onClose={closeForm} />
      )}

      {["exam", "answer"].includes(activeForm) && (
        <FormModal formType={activeForm} onClose={closeForm} />
      )}


    </>

  );
};

export default AdminActions;
